import { FC, useEffect } from "react";

import { Lock, User } from "shared/assets/icons";
import { SideMenu } from "shared/components";
import { ISideMenuItem } from "shared/components/SideMenu/types";
import { copy } from "shared/assets";

import { BAND_PATHS } from "Bands/router";
import { useBandContext, usePermissionsContext } from "Bands/contexts";
import { useMemo } from "react";
import { useBandRoute } from "Bands/utils";
import { buildUrl } from "shared/utils";
import { useDispatch } from "react-redux";
import { getPermissionTypes } from "Bands/state";

const {
  members: { title, sidemenu },
} = copy;

export const MembersSideMenu: FC = () => {
  const { rootGroups, userCanManageMembers } = usePermissionsContext();
  const { bandId } = useBandContext();
  const { getPath } = useBandRoute();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!bandId) return;

    dispatch(getPermissionTypes(bandId));
  }, [dispatch, bandId]);

  const items: ISideMenuItem[] = useMemo(() => {
    const sideMenuItems = [] as ISideMenuItem[];

    if (!bandId) return [];

    sideMenuItems.push({
      id: "overview",
      title: sidemenu.members,
      path: getPath(BAND_PATHS.MEMBERS),
      icon: User,
    });

    if (userCanManageMembers && rootGroups) {
      sideMenuItems.push({
        id: "permissions",
        title: sidemenu.permissions,
        icon: Lock,
        expandableSubItems: true,
        subItems: rootGroups.map(({ id, label }) => ({
          id,
          title: label,
          path: getPath(BAND_PATHS.PERMISSION_GROUP, {
            params: { groupId: id },
          }),
        })),
      });
    }

    return sideMenuItems;
  }, [bandId, getPath, rootGroups, userCanManageMembers]);

  if (!bandId) return null;

  return (
    <SideMenu title={title} titleUrl={buildUrl(BAND_PATHS.MEMBERS, { bandId })} items={items} />
  );
};
